import { render, staticRenderFns } from "./CSubSelector.vue?vue&type=template&id=58a1add7&"
import script from "./CSubSelector.vue?vue&type=script&lang=js&"
export * from "./CSubSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports